import React from 'react'
import { Form, Formik } from 'formik'
import Button from './common/Button'
import { required } from '../utils/validators'
import Input from './common/Input'
import useTrans from '../hooks/trans'

export default function TerritoryForm({ onSubmit, onCancel, loading, initialValues = {} }) {
    const t = useTrans()

    return (
        <Formik onSubmit={onSubmit} initialValues={{ name: '', ...initialValues }}>
            <Form>
                <Input name="name" label={t('name')} validate={required} autoFocus autoComplete="off" />

                <div className="is-pulled-right">
                    <Button
                        onClick={onCancel}
                        icon="ion-md-close"
                        text={t('cancel')}
                        disabled={loading}
                        className="is-danger" />&nbsp;&nbsp;

                    <Button
                        loading={loading}
                        text={t('save')}
                        type="submit"
                        icon="ion-md-checkmark"
                        disabled={loading}
                        className="is-success" />
                </div>
            </Form>
        </Formik>
    )
}
